import { Col, Row } from "antd";
import CustomCard from "components/CustomCard";
import PageHeader from "components/PageHeader";
import CustomerCompletedTab from "features/PotentialCustomer/PotentialCustomerList/CustomerCompletedTab/customerCompletedTab";
import { useGetCountPotentialCustomer } from "hooks/potentialCustomer/query";
import { useTotalByStatus } from "hooks/seller";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { buildQueryString, getQuery } from "utils/helperFuncs";
import AgentTab from "./AgentTab";

export default function AgentTabs() {
  const GET_QUERY = getQuery();
  const [activeKeyMain, setActiveKeyMain] = useState(GET_QUERY?.statuses || "AGENT");
  const { completeCaringCount } = useGetCountPotentialCustomer();
  const { data: dataTotalByStatus } = useTotalByStatus();

  const [reloadKey, setReloadKey] = useState(0);

  const handleChangeTab = (activeKey) => {
    setActiveKeyMain(activeKey);
    buildQueryString({
      params: { statuses: activeKey },
    });
  };

  // Nhấn lại chính tab đang mở cũng phải xoá filter về mặc định như khi nhấn tab bên cạnh — nếu
  // không thì filter chỉ nằm trên URL (vd `customerIDs` khi điều hướng từ màn Đơn hàng sang) không
  // có cách nào gỡ. Phải đổi `reloadKey` để remount vì tab chỉ đọc URL đúng một lần lúc mount.
  const handleTabClick = (activeKey) => {
    if (activeKey !== activeKeyMain) return;
    handleChangeTab(activeKey);
    setReloadKey((prev) => prev + 1);
  };

  const tabList = [
    {
      key: "COMPLETE_CARING",
      tab: `${t("seller.sellerWaitApprove")} (${completeCaringCount || 0})`,
    },
    {
      key: "AGENT",
      tab: `${t("seller.seller")} (${dataTotalByStatus?.approval || 0})`,
    },
  ];

  const contentList = {
    COMPLETE_CARING: <CustomerCompletedTab isAgent key={reloadKey} />,
    AGENT: <AgentTab key={reloadKey} />,
  };

  useEffect(() => {
    buildQueryString({
      params: {
        statuses: GET_QUERY.statuses || "AGENT",
        ...GET_QUERY,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GET_QUERY.statuses]);

  return (
    <Row>
      <Col span={24}>
        <PageHeader
          pageTitle={t("seller.sellerAccList")}
          routes={[
            {
              path: "/setting",
              name: t("seller.systemSetting"),
            },
            {
              path: "",
              name: t("seller.sellerAccManage"),
            },
          ]}
        />
      </Col>
      <Col span={24}>
        <CustomCard
          tabList={tabList}
          onTabChange={handleChangeTab}
          onTabClick={handleTabClick}
          defaultActiveTabKey={activeKeyMain}
          contentList={contentList}
          activeTabKey={activeKeyMain}
        />
      </Col>
    </Row>
  );
}
